
import { useState } from 'react';

export default function WebProduction() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section className="min-h-screen py-16 px-8 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <h2 className="text-4xl md:text-5xl font-light text-white mb-24 tracking-[0.2em]">
          Web Production
        </h2>

        {/* Image and Text Layout */}
        <div className="space-y-12">
          {/* Image Area */}
          <div 
            className="relative group cursor-pointer"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className="relative overflow-hidden rounded-sm">
              <img
                src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/4e7a1df60bc07c7973974194b8d67985.png"
                alt="Web Production Showcase"
                className={`w-full h-auto object-cover transition-all duration-700 ${
                  isHovered ? 'brightness-110 scale-105' : 'brightness-75'
                }`}
              />
              <div 
                className={`absolute inset-0 transition-opacity duration-700 ${
                  isHovered ? 'opacity-0' : 'opacity-30'
                }`}
                style={{
                  background: 'radial-gradient(circle at center, transparent 0%, rgba(18, 18, 18, 0.6) 100%)',
                }}
              />
              {/* Glow effect on hover */}
              <div 
                className={`absolute inset-0 transition-opacity duration-700 ${
                  isHovered ? 'opacity-100' : 'opacity-0'
                }`}
                style={{
                  boxShadow: '0 0 60px rgba(255, 255, 255, 0.3), inset 0 0 60px rgba(255, 255, 255, 0.1)',
                }}
              />
            </div>
          </div>

          {/* Text Area */}
          <div className="space-y-6 max-w-5xl mx-auto">
            <p className="text-xl md:text-2xl text-white/80 font-light leading-relaxed tracking-wide">
              ダイエットや体型改善に悩むユーザーは、期待と同じくらい大きな不安を抱えています。だからこそ、このLPでは何よりも視覚的な「安心感」を最優先に設計しました。
            </p>
            <p className="text-xl md:text-2xl text-white/80 font-light leading-relaxed tracking-wide">
              温かみのあるピンクを基調としつつ、信頼感を損なわない清潔感のあるトーンを意識。特に「お客様の声」は、単なる情報の羅列ではなく「私にもできるかも」と希望を持ってもらえるよう、可読性と共感性を重視したレイアウトに仕上げています。
            </p>
            <p className="text-xl md:text-2xl text-white/80 font-light leading-relaxed tracking-wide">
              ただ情報を整えるのではなく、画面の向こうにいるユーザーの不安を和らげ、勇気を出して最初の一歩を踏み出してもらえるような、背中を優しく押せるデザインを目指しました。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
